/*!

=========================================================
* - v1.4.0
=========================================================

* Product Page: 
* Copyright 2020 Ahmed Abosaif
* Licensed under MIT Ahmed Abosaif

* Coded by Ahmed Abosaif

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React, { useEffect, useState } from "react";

import { NavLink } from "react-router-dom";
import { Nav ,Dropdown , ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem,Badge  } from "reactstrap";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";

import logo from "./hd-logo.png";

var ps;

class Sidebar extends React.Component {
 

  constructor(props) {


    super(props);
    this.activeRoute.bind(this);
this.state = {
userActive:""

}


  }



  // verifies if routeName is the one active (in browser input)
  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  }






  

  
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
  }
  render() {

//Main NAV ITEMS Start **************************************************************
let MainNavItems = this.props.routes.map((prop, key) => {
  if (prop.redirect) return null;
  return (
    <li
      className={
        this.activeRoute(prop.layout + prop.path) +
        (prop.pro ? " active active-pro" : "")
      }
      key={key}
    >
      <NavLink
        to={prop.layout + prop.path}
        className="nav-link"
        activeClassName="active"
      >
        <i className={"now-ui-icons " + prop.icon} />
        <p>{prop.name}{prop.num && this.state.userActive > 0 ? <Badge color="danger" id="testaoo" style={{fontSize:12 , marginLeft:20}}>{this.state.userActive}</Badge> :null}</p>
      </NavLink>
    </li>
  );
});
//Main NAV ITEMS END **************************************************************

/*

const ReportingItem = (props) => {
  const [dropdownOpen, setOpen] = useState(false);

  const toggle = () => setOpen(!dropdownOpen);

  return (
<Dropdown
nav
isOpen={dropdownOpen}
toggle={toggle}
>
 <DropdownToggle   nav>
 <p><i className="now-ui-icons users_single-02" />Reporting</p>

</DropdownToggle>
<DropdownMenu right style={{width:"95%"}}>

 {this.props.reportingroutes.map((prop, key) => {
  if (prop.redirect) return null;
  return (


                <DropdownItem
      
      key={key} >


      <NavLink
        to={prop.layout + prop.path}
        className="nav-link"
        activeClassName="active"
      >
        <p style={{color:"rgb(65,70,75)"}}>{prop.name}</p>
      </NavLink>
      </DropdownItem>
   
  );
})}

</DropdownMenu>

</Dropdown>

  );
}
*/









    return (
      <div className="sidebar" data-color={'green'}>
        <div className="logo" style={{backgroundColor:"rgb(65,70,75)"}}>
          <a
            href="#"
            className="simple-text"
            target="_blank"
          >
            <div className="logo-img">
              <img src={logo} alt="react-logo" style={{width:'80%'}} />
            </div>
          </a>
          <a
            href="#"
            className="simple-text logo-normal"
            target="_blank"
          >
          &nbsp;	&nbsp;	<strong>IT Ticketing System </strong>
          </a>
          
        </div>
        <div className="sidebar-wrapper" ref="sidebar">
          <Nav>

          {MainNavItems}




            
          </Nav>
        </div>
      </div>
    );
  }
}

export default Sidebar;
